import React from 'react'
import Lottie from 'react-lottie'
import animationData from './images/33337-tick-pop'


export default function LottieSuccess() {
    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "33337-tick-pop"
        }
      };
    
    return (
      <div className='lottiediv'>
        <Lottie 
          options={defaultOptions}
          height={60}
          width={60}
        />
      </div>
    );
  }
